module.exports = __webpack_public_path__ + "assets/ff60ad4b40571590704e89440b14d0a7.mp3";


/*****************
 ** WEBPACK FOOTER
 ** ./public-src/sounds/win/Level6_Hit24s.mp3
 ** module id = 339
 ** module chunks = 0
 **/